import React, { useContext } from 'react';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { DoorClient, DoorTranslation, EditDoorRequest, IDoor2 } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { useState2 } from '../../../util/useState2';
import { ImageSetter } from '../MaterialEditor/ImageSetter';

export function SingleDoorAdmin(props: {
    onChange: () => void;
    door: IDoor2;
}) {

    const tc = useContext(TranslationContext);
    const translations = useState2(() => props.door.doorTranslations.map(dt => ({
        ...dt,
        isChanged: false
    })));
    const selectedTranslationIndex = useState2(0);
    const selectedTranslation = translations.value[selectedTranslationIndex.value];

    const client = useClient(DoorClient);

    async function save(evt: React.FormEvent) {
        evt.preventDefault();
        try {
            await client.editDoor(props.door.id, new EditDoorRequest({
                translations: translations.value
                    .filter(t => t.isChanged)
                    .map(t => new DoorTranslation({
                        languageId: t.languageId,
                        name: t.name,
                        description: t.description,
                        languageName: ""
                    })),
            }));
        }
        finally {
            props.onChange();
        }
    }

    async function setImage(f: File) {
        try {
            const extension = f.type.split("/")[1];
            await client.setDoorImage(props.door.id,
                extension,
                {
                    data: f,
                    fileName: File.name
                });
        }
        finally {
            props.onChange();
        }
    }

    function setStringProp(propName: ("name" | "description"), value: string) {
        const newTranslation = {
            ...selectedTranslation,
            isChanged: true
        };
        newTranslation[propName] = value;
        const newTranslations = [...translations.value];
        newTranslations[selectedTranslationIndex.value] = newTranslation;
        translations.set(newTranslations);
    }

    return (
        <div className="single-door-admin container container-fluid">
            <div className="row">
                <form onSubmit={save}>

                    <div className="form-group">
                        <label htmlFor="door-translation-language">
                            {tc.translator("admin edit door language", "Sprog")}
                        </label>
                        <select id="door-translation-language"
                            className="form-control"
                            value={selectedTranslationIndex.value}
                            onChange={evt => selectedTranslationIndex.set(parseInt(evt.target.value))}
                        >
                            {translations.value.map((t, index) => (
                                <option key={index} value={index}>
                                    {t.languageName}
                                </option>
                            ))
                            }
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="door-name">
                            {tc.translator("admin door name label", "Navn")}
                        </label>
                        <input id="door-name"
                            className="form-control"
                            value={selectedTranslation.name}
                            onChange={evt => setStringProp("name", evt.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="desc">
                            {tc.translator("admin door description label", "Beskrivelse")}
                        </label>
                        <textarea className="form-control" id="desc" rows={6}
                            value={selectedTranslation.description}
                            onChange={evt => setStringProp("description", evt.target.value)}
                        />
                    </div>

                    <button className="btn btn-primary" type="submit">
                        {tc.translator("admin edit door button", "Gem")}
                    </button>


                    <ImageSetter onSet={setImage} url={props.door.imageUrl} />

                </form>
            </div>
        </div>
    );
}
